import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { projectedCrossPaths } from '../queries/paths';

// TSS vite/03 — typeahead de cruces proyecto (donadora × toro, admin-projected-crosses.md).
// Busca por `q` (code/name); trae `donor`/`sire` embebidos. q < 2 chars → no dispara.
// Permiso: projected_crosses:read.

export function useProjectedCrossSearch(q, { limit = 10 } = {}) {
    const term = (q || '').trim();
    return useQuery({
        queryKey: ['projected-crosses', 'search', term, limit],
        queryFn:  ({ signal }) =>
            api.get(projectedCrossPaths.list(), { params: { q: term, limit, status: 2, sort: 'code' }, signal }).then(r => r.data),
        enabled: term.length >= 2,
        placeholderData: (prev) => prev,
    });
}
